<template>
	<router-link
		v-if="title"
		:to="navigateTo"
		active-class="selected"
		@click.native="$emit('close')"
		class="width-100 display-flex flex-row flex-align-center placement-menu-item-container"
	>
		<div v-if="icon" class="mr-2">
			<SIcon width="16" height="16" :name="icon" />
		</div>
		<div class="item-name display-flex flex-row flex-align-center one-row flex-1">
			{{ title }}
		</div>
		<div v-if="additionalInfo" class="additional-info one-row flex-1">
			{{ additionalInfo }}
		</div>
	</router-link>
</template>
<script>
export default {
	name: 'PlacementMenuItemRouterLink',
	props: { icon: { type: String }, title: { type: String }, navigateTo: { type: Object }, additionalInfo: { type: String } },
};
</script>
<style scoped lang="scss">
.placement-menu-item-container {
	height: 26px;
	cursor: pointer;
	padding-left: 6px;
	border-radius: 7px;
	text-decoration: none;
	&:hover {
		background: #f4f5f66c;
	}
	&.selected {
		display: flex;
		background: #f4f5f6;
		.item-name {
			font-weight: 600;
		}
	}
}
.item-name {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);
}
.additional-info {
	font-size: 12px;
	color: #9095ac;
	margin: 1px 0 0 6px;
}
</style>
